function getAgentGiftRules ({ dailyLimitLabel } = {}) {
  const limitLabel = dailyLimitLabel || '500.00'
  return [
    {
      title: 'Agent staff only',
      text: 'Only agent staff can send or receive gifts.'
    },
    {
      title: 'Daily limit',
      text: 'You can send up to ' + limitLabel + ' in gifts every 24 hours.'
    },
    {
      title: 'Accept to receive',
      text: 'The amount leaves your balance as soon as you send it. It is added to the recipient\'s balance only after they accept.'
    },
    {
      title: 'Decline or cancel',
      text: 'From Your Transactions, the recipient can decline and you can cancel before it is accepted. Either way, the amount is returned to you.'
    },
    {
      title: 'Mobile money',
      text: 'Gift credit cannot be refunded to mobile money unless SmartTransyt support gives you permission.'
    },
    {
      title: 'Who you can send to',
      text: 'You cannot send a gift to yourself. The recipient must be agent staff with a registered phone number or email address.'
    }
  ]
}

module.exports = {
  getAgentGiftRules
}
